import Menu from "@material-ui/core/esm/Menu";
import IconButton from "@material-ui/core/esm/IconButton";
import MenuItem from "@material-ui/core/esm/MenuItem";
import Collapse from "@material-ui/core/esm/Collapse";
import List from "@material-ui/core/esm/List";
import ClickAwayListener from "@material-ui/core/esm/ClickAwayListener";
import AccountCircle from "@material-ui/icons/esm/AccountCircle";
import Person from "@material-ui/icons/esm/Person";
import SupervisorAccount from "@material-ui/icons/esm/SupervisorAccount";
import Language from "@material-ui/icons/esm/Language";
import ExitToApp from "@material-ui/icons/esm/ExitToApp";
import HelpOutline from "@material-ui/icons/esm/HelpOutline";
import dayjs from 'dayjs';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch, useHistory, Link } from 'react-router-dom';
import { useMSAL } from 'auth/msalProvider';
import Lang from 'constants/language';
import { CONTACT_US } from 'constants/urls';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import { CUSTOMERS, CREATE_CUSTOMER } from 'routes/customers/paths';
import PROFILE from 'routes/profile/paths';
import useStyles from '../NavigationStyles';
const NavigationProfileMenu = () => {
  const onCustomersPage = useRouteMatch(CUSTOMERS)?.isExact;
  const onCreateCustomerPage = useRouteMatch(CREATE_CUSTOMER)?.isExact;
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(null);
  const {
    language,
    icon,
    profileMenu,
    menu,
    contactUs
  } = useStyles();
  const {
    t,
    i18n
  } = useTranslation();
  const {
    push
  } = useHistory();
  const {
    logout
  } = useMSAL();
  const {
    resetCustomer
  } = useCurrentCustomer();
  const open = Boolean(isOpen);
  const handleLanguageMenu = () => {
    setIsLanguageMenuOpen(!isLanguageMenuOpen);
  };
  const handleMenu = event => {
    setIsOpen(event.currentTarget);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleClose = event => {
    // Prevent from closing menu when pressing the language menu button
    if (event?.target?.ariaLabel === 'language menu button') return;
    setIsOpen(null);
  };
  const changeLanguage = lng => () => {
    setIsOpen(null);
    setIsLanguageMenuOpen(false);
    i18n.changeLanguage(lng);
  };
  const handleProfileClick = () => {
    push(PROFILE);
    handleClose();
  };
  const handleCustomersClick = () => {
    resetCustomer();
    push(CUSTOMERS);
    handleClose();
  };
  const handleContactUsClick = () => {
    handleClose();
  };
  const handleLogoutClick = () => {
    resetCustomer();
    logout();
    handleClose();
  };
  useEffect(() => {
    const lang = i18n.languages[0];
    dayjs.locale(lang);
  }, [i18n.languages]);
  return /*#__PURE__*/React.createElement(ClickAwayListener, {
    disableReactTree: true,
    onClickAway: handleClose
  }, /*#__PURE__*/React.createElement("div", {
    className: menu
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "account of current user",
    "aria-controls": "menu-appbar",
    "aria-haspopup": "true",
    onClick: handleMenu,
    color: "inherit"
  }, /*#__PURE__*/React.createElement(AccountCircle, null)), /*#__PURE__*/React.createElement(Menu, {
    id: "menu-appbar",
    anchorEl: isOpen,
    keepMounted: true,
    onEscapeKeyDown: handleClose,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: open,
    onClose: handleClose,
    className: profileMenu
  }, !onCustomersPage && !onCreateCustomerPage && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleProfileClick,
    "aria-label": "profile menu button"
  }, /*#__PURE__*/React.createElement(Person, {
    className: icon
  }), t('profile_menu.profile')), !onCustomersPage && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleCustomersClick,
    "aria-label": "customers menu button"
  }, /*#__PURE__*/React.createElement(SupervisorAccount, {
    className: icon
  }), t('profile_menu.customers')), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleLanguageMenu,
    className: language,
    "aria-label": "language menu button"
  }, /*#__PURE__*/React.createElement(Language, {
    className: icon
  }), t('profile_menu.language')), /*#__PURE__*/React.createElement(Collapse, {
    in: isLanguageMenuOpen,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(List, {
    component: "div",
    disablePadding: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: changeLanguage(Lang.english),
    "aria-label": "english language button"
  }, t('profile_menu.languages.english')), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: changeLanguage(Lang.norwegian),
    "aria-label": "norwegian language button"
  }, t('profile_menu.languages.norwegian')))), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleContactUsClick,
    "aria-label": "contact us"
  }, /*#__PURE__*/React.createElement(Link, {
    to: {
      pathname: CONTACT_US
    },
    target: "_blank",
    rel: "noopener noreferrer",
    className: contactUs
  }, /*#__PURE__*/React.createElement(HelpOutline, {
    className: icon
  }), t('profile_menu.contact_us'))), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleLogoutClick,
    "aria-label": "logout button"
  }, /*#__PURE__*/React.createElement(ExitToApp, {
    className: icon
  }), t('profile_menu.logout')))));
};
export default NavigationProfileMenu;